import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateLeagueMapping } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew";
import { UpdateLeagueMappingParams } from "@/types/ApiResponses/League";

export const useUpdateLeagueMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateLeagueMappingParams) =>
      updateLeagueMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [LeaguesNewQueryKeys.LeagueMappings, variables.leagueId],
      });
    },
  });
};
